import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthService} from '@core/services/auth.service';
import {Router} from '@angular/router';
import {DestroyObsService} from '@core/services/destroy-obs.service';
import {UserService} from '@core/services/user.service';
import {IUser, Notis} from '@core/models/user';
import {WebsocketService} from '@core/services/websocket.service';
import {take, takeUntil} from 'rxjs/operators';
import {SideNavService} from '@core/services/side-nav.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [DestroyObsService]
})
export class HeaderComponent implements OnInit {

    user$ = this.userService.getUser$;

    newNotis: boolean;
    showNotis: boolean;
    list: Notis[];
    countNewMsg: number;

    constructor(private authService: AuthService,
                private destroy$: DestroyObsService,
                private userService: UserService,
                public sideNavService: SideNavService,
                private socket: WebsocketService,
                private wsService: WebsocketService) {
    }

    ngOnInit(): void {
        this.user$
            .pipe(take(1), takeUntil(this.destroy$))
            .subscribe(user => this.socket.connect(user.id))
            .unsubscribe();
        this.userService.getNotis()
            .subscribe(list =>  {
                this.list = list;
                this.countNewMsg = this.list.filter(f => !f.read_at)?.length || null;
            });
        this.wsService.on()
            .subscribe((res: { message: string, like: string, title: string, date: string }) => {
                const notis: Notis = {read_at: null, data: res};
                this.list.unshift(notis);
                this.countNewMsg = this.list.filter(f => !f.read_at)?.length || null;
            });
    }

    logout() {
        this.authService.logout();
    }

    getName(user: IUser) {
        if (user.surname) {
            const name = user.name?.substr(0, 1);
            const patronymic = user.patronymic?.substr(0, 1);
            return `${user.surname} ${name ? name + '.' : ''} ${patronymic ? patronymic + '.' : ''}`;
        } else {
            return user.email || 'Пользователь';
        }
    }

    clear() {
        this.showNotis = false;
        this.list = [];
        this.countNewMsg = null;
    }

    openSideNav() {
        this.sideNavService.toggle();
    }
}
